// extracted by mini-css-extract-plugin
export default {"intl-tel-input":"phone-input_intl-tel-input__JtF-M","phone__btm--input":"phone-input_phone__btm--input__azXnG"};